const riot = require('riot');

riot.tag2('atom-indicator', '<div class="f fh"><img class="s-full animation-spin animation" src="/images/indicator.svg"></div>', 'atom-indicator,[data-is="atom-indicator"]{display:block}', '', function(opts) {
});